import React, { useState } from "react";
import { Link } from "react-router-dom";

// ============================================================================
// 58-CARD PRINT-READY GENERATOR
// Dimensions: 825 × 1425 px = 2.75" × 4.75" at 300 DPI
// (Standard tarot/oracle size — DriveThruCards & MPC ready)
// ============================================================================

export const DECK_GEN = [
  // MIND (1–12)
  { n: 1, title: "I GET TO", cat: "MIND", body: "Every time you catch \"I have to\" on your tongue today — use \"I GET TO.\" Same task. Same Tuesday. Different woman standing in it.", walk: "Notice three \"I have to's\" before lunch. Reframe one out loud." },
  { n: 2, title: "Cut the Word TRY", cat: "MIND", body: "\"I'll try\" is the polite cousin of self-abandonment. Yes is yes. No is no. Today, cut the word from your vocabulary.", walk: "When TRY shows up — ask: am I yes or no? Pick one." },
  { n: 3, title: "The Buck Stops Here", cat: "MIND", body: "Whatever pattern walked into you from generations back — it does not have to walk out the same way. Today the buck stops here.", walk: "Name one inherited pattern you are refusing to pass forward." },
  { n: 4, title: "Awareness", cat: "MIND", body: "First you have to see it. Not fix it. Not name it pretty. Just see what is.", walk: "Sit for 60 seconds. Ask — what am I actually feeling?" },
  { n: 5, title: "Clarity", cat: "MIND", body: "Once you see it, get specific. Vague gets vague results.", walk: "Finish this sentence honestly — I actually want _______." },
  { n: 6, title: "Compassionate Curiosity", cat: "MIND", body: "Not \"why am I like this?\" — that's a beating. Use \"what is this here to teach me?\" — that's curiosity.", walk: "Replace one self-critical thought with one curious one today." },
  { n: 7, title: "Start Small", cat: "MIND", body: "Do not make BIG choices from trauma, fight, or flight. Start small. The small things compound.", walk: "What is the next right tiny step? Do that one." },
  { n: 8, title: "Take What Resonates", cat: "MIND", body: "Not every truth is your truth on this day. Take what resonates. Leave the rest. The message lives in you.", walk: "One thing today — receive it. Decide if it's yours." },
  { n: 9, title: "Stop Abandoning Yourself", cat: "MIND", body: "Every yes you don't mean is a chip off your power. Today — notice the abandoning. Stop the abandoning.", walk: "Where did you say yes when you meant no? Reset one of them." },
  { n: 10, title: "Reclaimed, Not Saved", cat: "MIND", body: "No one is coming to save you. That is not a tragedy — that is a graduation. You reclaim yourself.", walk: "Name one thing today you are reclaiming. Out loud." },
  { n: 11, title: "The Messy Middle", cat: "MIND", body: "You are not behind. You are not broken. You are in the messy middle. That is the holy place where the work gets done.", walk: "Forgive yourself for not being further along by now." },
  { n: 12, title: "Listen for the Lie", cat: "MIND", body: "Every inherited story has a lie inside it. \"I'm too much.\" \"I'm not enough.\" Today, listen for the lie.", walk: "Catch one lie. Replace it with one truth. Write both down." },

  // BODY (13–24)
  { n: 13, title: "Breathe", cat: "BODY", body: "Four counts in. Hold four. Six counts out. Your nervous system follows your breath. The room did not change — but you did.", walk: "Three rounds. Right now." },
  { n: 14, title: "Ground", cat: "BODY", body: "Feet on the floor. Hands on something solid. Name five things you see. The body remembers it is safe.", walk: "Do the 5-4-3-2-1 right now. Out loud if you can." },
  { n: 15, title: "Water", cat: "BODY", body: "When in doubt, drink water. Your body is mostly water.", walk: "A full glass. Right now." },
  { n: 16, title: "Walk", cat: "BODY", body: "Twenty minutes outside changes the shape of your day. Not a workout — a walk. Phone in pocket, not in hand.", walk: "Today. Twenty minutes. Door to door." },
  { n: 17, title: "Sleep Hygiene", cat: "BODY", body: "What you do at 9pm decides who you wake up as at 6am. Phone down. Lights low. Body slow.", walk: "Pick one thing to do differently tonight." },
  { n: 18, title: "The Adrenal Truth", cat: "BODY", body: "If you have been running on fumes — your body will eventually pick the brake for you. Slow down before it slows you.", walk: "One commitment you can release this week. Say it." },
  { n: 19, title: "Eat Real Food", cat: "BODY", body: "Most days, how you feel started on a plate. No diet. No rules. Just one real meal.", walk: "Make one meal today from real, whole ingredients." },
  { n: 20, title: "The Body Is a Messenger", cat: "BODY", body: "Your symptoms are not the problem. They are the messenger. Listen before you medicate. The body always knows.", walk: "What is your body here to say today? Write it." },
  { n: 21, title: "Stillness", cat: "BODY", body: "You do not need to add another practice. You need stillness. Five minutes. No phone. Just sit.", walk: "Set a timer. Sit. That's it." },
  { n: 22, title: "Rest Is Work", cat: "BODY", body: "Rest is not the reward for productivity. Rest IS the work. The world wants you tired so it can sell you energy.", walk: "Nap today. Without apology." },
  { n: 23, title: "Touch", cat: "BODY", body: "Hand on your heart. Hand on your belly. Touch from your own hand is real medicine. The body knows the difference between abandoning and tending.", walk: "Five minutes. Hand on heart. Just breathe." },
  { n: 24, title: "The 50% Rule", cat: "BODY", body: "If you are at 50% capacity today — make 50% your full effort. Do not stretch a depleted body. Pick the two essentials.", walk: "What are today's two? Do those. Drop the others." },

  // SPIRIT (25–36)
  { n: 25, title: "Tapped In", cat: "SPIRIT", body: "I tap in. I ground. I say hello. I say thank you. That is the entire ritual.", walk: "Three breaths. Then say hello to whoever guides you." },
  { n: 26, title: "Purple Chopsticks", cat: "SPIRIT", body: "It could be God. It could be the angels. It could be the kitchen window light at 7am. Whatever lights you up — that's the Divine.", walk: "Today, notice where the light finds you. Thank it." },
  { n: 27, title: "Ask for a Sign", cat: "SPIRIT", body: "If you need direction, ask. Then watch with your eyes wide open. The signs were never quiet — you were just not looking.", walk: "Ask for a specific sign. Then keep your head up today." },
  { n: 28, title: "Welcome Home", cat: "SPIRIT", body: "You can come back to yourself any time. There is no late. There is no missed window. The door is open.", walk: "Welcome home." },
  { n: 29, title: "The Divine Team", cat: "SPIRIT", body: "You are not doing this alone. Holy Spirit, angels, guides, ancestors — they are working with you.", walk: "Ask one of them for help today. By name. Out loud." },
  { n: 30, title: "Gratitude Is a Frequency", cat: "SPIRIT", body: "Not the toxic-positivity kind. The \"I get to take out this trash because I have a home\" kind.", walk: "Three real gratitudes. Out loud. Specific." },
  { n: 31, title: "Prayer Is a Conversation", cat: "SPIRIT", body: "Prayer is not begging. Prayer is sitting at the kitchen table with the Divine and saying — here is what's true.", walk: "Say one true thing to God today. The truer, the better." },
  { n: 32, title: "Trust What You Heard", cat: "SPIRIT", body: "You asked. You heard. Now trust what you heard. The doubting is the work.", walk: "Act on the inner nudge that won't go away." },
  { n: 33, title: "Ancestors", cat: "SPIRIT", body: "Some of your ancestors are working FOR you right now. The line did not die. It is praying you forward.", walk: "Thank one ancestor by name today." },
  { n: 34, title: "High Integrity", cat: "SPIRIT", body: "When in doubt — ask: is this for the highest good of all? If yes, walk forward. If no, wait.", walk: "One decision today — run it through that question first." },
  { n: 35, title: "Surrender", cat: "SPIRIT", body: "Surrender is not giving up. Surrender is putting down the hammer you've been swinging at God's plan.", walk: "One thing you are surrendering today. Write it. Burn it." },
  { n: 36, title: "I Am a Vessel", cat: "SPIRIT", body: "I am not the source. I am the vessel. The minute I forget that, the work gets heavy.", walk: "Get out of the way today. Let what wants to come — come." },

  // HYGIENE (37–48)
  { n: 37, title: "Daily · Non-Negotiable · Yours", cat: "HYGIENE", body: "Mind, body, spirit hygiene is not a vibe. It is a practice. Daily. Non-negotiable. Yours.", walk: "Pick one HYGIENE practice. Do it before noon. Without excuse." },
  { n: 38, title: "Not Transformation", cat: "HYGIENE", body: "You do not need to transform. You need to maintain hygiene. The same way you brush your teeth.", walk: "What is your spiritual equivalent of brushing your teeth? Do it." },
  { n: 39, title: "The PCC", cat: "HYGIENE", body: "What are your non-negotiables — for yourself, by yourself? Write three. Live by them.", walk: "Today, pick one PCC line. Hold it without exception." },
  { n: 40, title: "The Morning Anchor", cat: "HYGIENE", body: "Whatever your first twenty minutes are — those set the tone. Phone last. Breath first.", walk: "Tomorrow — no phone for the first twenty minutes." },
  { n: 41, title: "The Evening Review", cat: "HYGIENE", body: "Three questions before sleep: What worked? What didn't? What will I foster tomorrow?", walk: "One sentence on each. Tonight. Before lights out." },
  { n: 42, title: "The Weekly Reset", cat: "HYGIENE", body: "Once a week — sit with yourself. What needs to shift? Without judgment. Just data.", walk: "Sunday. Twenty minutes. With a pen. With yourself." },
  { n: 43, title: "Emergency Calm", cat: "HYGIENE", body: "When the panic rises: hand on heart. Long exhale. Name what is true RIGHT NOW. The body can only hold one nervous system state at a time.", walk: "Three exhales. Each longer than the inhale." },
  { n: 44, title: "Clean House = Clean Mind", cat: "HYGIENE", body: "The state of your space is the state of your mind made visible.", walk: "One room. Ten minutes. Reset." },
  { n: 45, title: "Social Media Hygiene", cat: "HYGIENE", body: "Whatever you consume becomes your nervous system. Curate or be consumed.", walk: "Unfollow three accounts that drain you. Today. Without apology." },
  { n: 46, title: "Word Hygiene", cat: "HYGIENE", body: "How you talk to yourself when no one is listening — that is the actual relationship of your life.", walk: "Catch one cruel inner sentence. Reframe it. Out loud." },
  { n: 47, title: "Tuesday Morning", cat: "HYGIENE", body: "Tuesday morning is the real test. Not Sunday's prayer. Not Saturday's reset. Tuesday morning, when nothing is special.", walk: "Show up Tuesday the way you swore on Sunday." },
  { n: 48, title: "The Buck Stops Here (Hygiene)", cat: "HYGIENE", body: "Whatever generational pattern walked into your hygiene — it does not have to walk out the same way. That ends with you.", walk: "Name one habit you are breaking for the line behind you." },

  // AGENCY (49–58)
  { n: 49, title: "My No Is No", cat: "AGENCY", body: "My no is no. It is not a negotiation. The explanation is for me. Not them.", walk: "One no today. Without softening it." },
  { n: 50, title: "Wait", cat: "AGENCY", body: "Yes. No. Or wait. The WAIT is where the wisdom lives.", walk: "Anything anyone needs an answer to today — give them the WAIT if it's true." },
  { n: 51, title: "Who Is This For?", cat: "AGENCY", body: "Before you do the thing — ask: who is this actually for? If the answer is \"them\" and you are depleted, stop.", walk: "One thing you were doing for them — put it down today." },
  { n: 52, title: "The Resentment Receipt", cat: "AGENCY", body: "Resentment is the receipt for a yes you should have said no to. If you are resentful — go back. Find the original yes.", walk: "Name one resentment. Trace it. What was the yes underneath?" },
  { n: 53, title: "People-Pleasing Is Self-Abandonment", cat: "AGENCY", body: "It is not kindness. It is self-abandonment in a softer voice.", walk: "One moment today — choose yourself over the polite version." },
  { n: 54, title: "No Explanation", cat: "AGENCY", body: "The explanation is for me. Not them. You do not have to defend a boundary to make it real.", walk: "One boundary today. No defense. No softener." },
  { n: 55, title: "Not Your Job", cat: "AGENCY", body: "Their healing is not your job. Their happiness is not your job. Their decisions are not your job.", walk: "Hand back one thing today that was never yours." },
  { n: 56, title: "Choose Yourself", cat: "AGENCY", body: "Choose yourself the way you would choose a daughter you love. With fierce, gentle protection.", walk: "What would you do for your daughter today? Do it for you." },
  { n: 57, title: "They Mean Well", cat: "AGENCY", body: "Some of the people who hurt you most — meant well. They simply did not know what they did not know.", walk: "One forgiveness offered today. Without requiring contact." },
  { n: 58, title: "Welcome Home", cat: "AGENCY", body: "You are the elder you needed. You are the home you were searching for. There is no version of yourself you have to earn. You are already here.", walk: "Welcome home." },
];

// Brand palette
const DEEP_TEAL   = "#042F2E";
const OCEAN_TEAL  = "#068fa2";
const BRIGHT_TEAL = "#25a1c2";
const CREAM       = "#efeae7";
const GOLD        = "#d4af6a";

// Category → theme
const CAT_THEME = {
  MIND:    { bg: DEEP_TEAL,                                                    text: CREAM,     accent: GOLD,      ribbon: GOLD },
  BODY:    { bg: CREAM,                                                        text: DEEP_TEAL, accent: OCEAN_TEAL, ribbon: BRIGHT_TEAL },
  SPIRIT:  { bg: `linear-gradient(160deg, ${DEEP_TEAL} 0%, ${OCEAN_TEAL} 100%)`, text: CREAM,     accent: GOLD,      ribbon: GOLD },
  HYGIENE: { bg: BRIGHT_TEAL,                                                  text: DEEP_TEAL, accent: DEEP_TEAL, ribbon: DEEP_TEAL },
  AGENCY:  { bg: CREAM,                                                        text: DEEP_TEAL, accent: GOLD,      ribbon: GOLD },
};

// ============================================================================
// CARD FRONT — 825 × 1425
// ============================================================================
export const CardFront = ({ card }) => {
  const t = CAT_THEME[card.cat];
  return (
    <div
      data-testid={`card-front-${card.n}`}
      style={{
        width: 825,
        height: 1425,
        background: t.bg,
        color: t.text,
        position: "relative",
        fontFamily: "'Georgia', 'Cormorant Garamond', serif",
        overflow: "hidden",
        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
      }}
    >
      {/* Inner frame */}
      <div
        style={{
          position: "absolute",
          inset: 50,
          border: `2px solid ${t.accent}`,
          borderRadius: 18,
          opacity: 0.55,
        }}
      />

      {/* Top eyebrow */}
      <div
        style={{
          position: "absolute",
          top: 95,
          left: 0,
          right: 0,
          textAlign: "center",
          fontFamily: "'Helvetica Neue', Arial, sans-serif",
          fontSize: 22,
          letterSpacing: "0.42em",
          color: t.accent,
          fontWeight: 600,
        }}
      >
        {card.cat}
      </div>

      {/* Card number badge */}
      <div
        style={{
          position: "absolute",
          top: 95,
          right: 95,
          fontFamily: "'Helvetica Neue', Arial, sans-serif",
          fontSize: 20,
          letterSpacing: "0.18em",
          color: t.accent,
          opacity: 0.85,
          fontWeight: 600,
        }}
      >
        {String(card.n).padStart(2, "0")}
      </div>

      {/* Tiny divider */}
      <div
        style={{
          position: "absolute",
          top: 150,
          left: "50%",
          transform: "translateX(-50%)",
          width: 60,
          height: 2,
          background: t.accent,
          opacity: 0.7,
        }}
      />

      {/* Title */}
      <div
        style={{
          position: "absolute",
          top: 200,
          left: 90,
          right: 90,
          textAlign: "center",
          fontSize: card.title.length > 22 ? 56 : 72,
          lineHeight: 1.05,
          fontWeight: 400,
          fontStyle: "italic",
          color: t.text,
          letterSpacing: "-0.01em",
        }}
      >
        {card.title}
      </div>

      {/* Body text */}
      <div
        style={{
          position: "absolute",
          top: 480,
          left: 100,
          right: 100,
          textAlign: "center",
          fontSize: 30,
          lineHeight: 1.45,
          fontWeight: 400,
          color: t.text,
          fontFamily: "'Georgia', serif",
        }}
      >
        {card.body}
      </div>

      {/* "The walk" block — bottom */}
      <div
        style={{
          position: "absolute",
          bottom: 180,
          left: 100,
          right: 100,
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontFamily: "'Helvetica Neue', Arial, sans-serif",
            fontSize: 16,
            letterSpacing: "0.35em",
            color: t.accent,
            marginBottom: 14,
            fontWeight: 600,
          }}
        >
          THE WALK
        </div>
        <div
          style={{
            fontSize: 22,
            lineHeight: 1.4,
            fontStyle: "italic",
            color: t.text,
            opacity: 0.92,
            fontFamily: "'Georgia', serif",
          }}
        >
          {card.walk}
        </div>
      </div>

      {/* Footer wordmark */}
      <div
        style={{
          position: "absolute",
          bottom: 85,
          left: 0,
          right: 0,
          textAlign: "center",
          fontFamily: "'Helvetica Neue', Arial, sans-serif",
          fontSize: 14,
          letterSpacing: "0.32em",
          color: t.accent,
          fontWeight: 600,
          opacity: 0.9,
        }}
      >
        MIND BODY SPIRIT HYGIENE&trade; TOOLS
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 60,
          left: 0,
          right: 0,
          textAlign: "center",
          fontFamily: "'Helvetica Neue', Arial, sans-serif",
          fontSize: 13,
          letterSpacing: "0.18em",
          color: t.text,
          opacity: 0.55,
        }}
      >
        {String(card.n).padStart(2, "0")} / 58
      </div>
    </div>
  );
};

// ============================================================================
// CARD BACK — 825 × 1425
// TEAL · wordmark · "with love, Temple Franklin & the Divine Team"
// ============================================================================
export const CardBack = () => {
  return (
    <div
      data-testid="card-back"
      style={{
        width: 825,
        height: 1425,
        background: `linear-gradient(160deg, ${OCEAN_TEAL} 0%, ${DEEP_TEAL} 100%)`,
        color: CREAM,
        position: "relative",
        fontFamily: "'Georgia', serif",
        overflow: "hidden",
      }}
    >
      {/* Inner gold frame */}
      <div
        style={{
          position: "absolute",
          inset: 50,
          border: `2px solid ${GOLD}`,
          borderRadius: 18,
          opacity: 0.6,
        }}
      />
      {/* Double inner frame */}
      <div
        style={{
          position: "absolute",
          inset: 72,
          border: `1px solid ${GOLD}`,
          borderRadius: 12,
          opacity: 0.35,
        }}
      />

      {/* Centered emblem block */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 90px",
          textAlign: "center",
        }}
      >
        {/* White feather — curved, tilted, floating · sign from spirit */}
        <svg
          width="260"
          height="300"
          viewBox="0 0 260 300"
          style={{ marginBottom: 28 }}
        >
          {/* outer ring */}
          <circle
            cx="130"
            cy="150"
            r="125"
            fill="none"
            stroke={GOLD}
            strokeWidth="1.4"
            opacity="0.5"
          />

          {/* drifting barb fragments (floating around the feather) */}
          <g stroke={CREAM} strokeWidth="0.9" fill="none" opacity="0.6">
            <path d="M 38 60 Q 46 56 54 60" />
            <path d="M 42 62 L 50 60" />
            <path d="M 215 230 Q 222 225 230 228" />
            <path d="M 218 232 L 226 230" />
            <path d="M 222 90 Q 228 86 232 88" />
            <path d="M 30 220 Q 38 217 42 219" />
          </g>

          {/* THE FEATHER — tilted, curved like it's drifting */}
          <g transform="rotate(-18 130 150)">
            {/* vane (white body, soft S-curve) */}
            <path
              d="M 130 22
                 C 100 44, 84 92, 86 142
                 C 88 184, 96 222, 108 254
                 L 116 270
                 C 126 240, 140 206, 154 164
                 C 168 122, 168 72, 144 38
                 C 138 30, 132 24, 130 22 Z"
              fill={CREAM}
              opacity="0.96"
            />

            {/* very soft inner shading (gives depth) */}
            <path
              d="M 130 22
                 C 108 44, 96 92, 98 142
                 C 100 184, 106 220, 116 254"
              stroke="#dcd3cc"
              strokeWidth="1"
              fill="none"
              opacity="0.5"
            />

            {/* rachis — curved central spine */}
            <path
              d="M 130 22
                 C 122 58, 118 96, 117 132
                 C 116 172, 115 212, 116 250
                 L 116 270"
              stroke="#a98a4f"
              strokeWidth="1.5"
              fill="none"
              opacity="0.7"
            />

            {/* barbs — LEFT side (angled upward toward feather tip) */}
            <g stroke={OCEAN_TEAL} strokeWidth="0.7" fill="none" opacity="0.35">
              <path d="M 124 40  Q 116 38  108 36" />
              <path d="M 122 52  Q 110 49  98  47" />
              <path d="M 120 66  Q 105 62  90  61" />
              <path d="M 119 82  Q 100 78  85  79" />
              <path d="M 118 100 Q 96  96  82  98" />
              <path d="M 118 120 Q 94  118 82  122" />
              <path d="M 117 142 Q 94  142 84  148" />
              <path d="M 117 164 Q 95  166 88  174" />
              <path d="M 117 186 Q 96  190 92  200" />
              <path d="M 116 208 Q 100 214 100 222" />
              <path d="M 116 228 Q 106 236 108 244" />
              <path d="M 116 248 Q 110 256 112 262" />
            </g>

            {/* barbs — RIGHT side */}
            <g stroke={OCEAN_TEAL} strokeWidth="0.7" fill="none" opacity="0.35">
              <path d="M 136 40  Q 144 36  152 36" />
              <path d="M 138 52  Q 150 48  160 48" />
              <path d="M 140 66  Q 156 60  168 60" />
              <path d="M 141 82  Q 160 76  172 78" />
              <path d="M 142 100 Q 164 94  176 100" />
              <path d="M 142 120 Q 166 118 174 126" />
              <path d="M 143 142 Q 164 142 170 152" />
              <path d="M 143 164 Q 160 168 164 178" />
              <path d="M 143 186 Q 158 192 158 202" />
              <path d="M 142 208 Q 154 216 152 224" />
              <path d="M 142 228 Q 148 236 146 244" />
              <path d="M 142 248 Q 142 256 140 262" />
            </g>

            {/* wispy split at the bottom of the vane (broken barbs · movement) */}
            <g stroke={CREAM} strokeWidth="0.7" fill="none" opacity="0.85">
              <path d="M 114 256 Q 106 262 100 266" />
              <path d="M 118 256 Q 124 262 130 266" />
              <path d="M 116 262 Q 110 268 106 272" />
              <path d="M 117 264 Q 122 270 126 272" />
            </g>

            {/* quill (calamus) — below the vane */}
            <path
              d="M 116 270 C 116 280, 116 286, 116 296"
              stroke={CREAM}
              strokeWidth="2.4"
              fill="none"
              opacity="0.9"
              strokeLinecap="round"
            />
            {/* quill subtle gold highlight */}
            <path
              d="M 116 272 L 116 290"
              stroke="#a98a4f"
              strokeWidth="0.6"
              fill="none"
              opacity="0.55"
            />
          </g>
        </svg>

        {/* Eyebrow */}
        <div
          style={{
            fontFamily: "'Helvetica Neue', Arial, sans-serif",
            fontSize: 18,
            letterSpacing: "0.5em",
            color: GOLD,
            marginBottom: 28,
            fontWeight: 600,
          }}
        >
          THE 58-CARD DECK
        </div>

        {/* Wordmark */}
        <div
          style={{
            fontFamily: "'Georgia', 'Cormorant Garamond', serif",
            fontSize: 58,
            fontStyle: "italic",
            lineHeight: 1.15,
            color: CREAM,
            marginBottom: 14,
            letterSpacing: "-0.01em",
          }}
        >
          Mind&nbsp;·&nbsp;Body
        </div>
        <div
          style={{
            fontFamily: "'Georgia', 'Cormorant Garamond', serif",
            fontSize: 58,
            fontStyle: "italic",
            lineHeight: 1.15,
            color: CREAM,
            marginBottom: 4,
            letterSpacing: "-0.01em",
          }}
        >
          Spirit
        </div>

        <div
          style={{
            fontFamily: "'Helvetica Neue', Arial, sans-serif",
            fontSize: 32,
            letterSpacing: "0.38em",
            color: GOLD,
            marginTop: 18,
            marginBottom: 50,
            fontWeight: 700,
          }}
        >
          HYGIENE&trade;
        </div>

        <div
          style={{
            fontFamily: "'Helvetica Neue', Arial, sans-serif",
            fontSize: 18,
            letterSpacing: "0.45em",
            color: CREAM,
            opacity: 0.85,
            marginBottom: 60,
            fontWeight: 500,
          }}
        >
          TOOLS
        </div>

        {/* Divider */}
        <div
          style={{
            width: 80,
            height: 1,
            background: GOLD,
            opacity: 0.8,
            marginBottom: 36,
          }}
        />

        {/* Signature */}
        <div
          style={{
            fontFamily: "'Georgia', serif",
            fontSize: 22,
            fontStyle: "italic",
            color: CREAM,
            opacity: 0.95,
            lineHeight: 1.5,
          }}
        >
          with love,
        </div>
        <div
          style={{
            fontFamily: "'Georgia', serif",
            fontSize: 24,
            fontStyle: "italic",
            color: CREAM,
            opacity: 0.95,
            marginTop: 4,
          }}
        >
          Temple Franklin
        </div>
        <div
          style={{
            fontFamily: "'Georgia', serif",
            fontSize: 20,
            fontStyle: "italic",
            color: GOLD,
            opacity: 0.95,
            marginTop: 6,
          }}
        >
          &amp; the Divine Team
        </div>
      </div>
    </div>
  );
};

// ============================================================================
// PAGE
// ============================================================================
const CardGenerator = () => {
  const [mode, setMode] = useState("preview"); // 'preview' | 'all'
  const [scale, setScale] = useState(0.45);

  return (
    <div className="min-h-screen bg-[#efeae7] pt-24 pb-24 px-4" data-testid="card-generator-page">
      {/* Header */}
      <div className="max-w-6xl mx-auto mb-10 text-center">
        <Link to="/draw" className="text-[#068fa2] underline text-sm" data-testid="back-to-draw">
          ← back to /draw
        </Link>
        <h1 className="font-serif italic text-4xl md:text-5xl text-[#042F2E] mt-4 mb-3">
          The 58-Card Deck — Print-Ready
        </h1>
        <p className="text-[#042F2E]/70 max-w-2xl mx-auto text-sm leading-relaxed">
          825 × 1425 px · 2.75" × 4.75" at 300 DPI · DriveThruCards / MPC ready.
          Showing at <strong>{Math.round(scale * 100)}%</strong> scale on screen — the actual rendered pixels are full print resolution.
        </p>

        {/* Controls */}
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <button
            onClick={() => setMode("preview")}
            data-testid="mode-preview"
            className={`px-5 py-2 rounded-full text-sm font-medium tracking-wide transition ${
              mode === "preview"
                ? "bg-[#042F2E] text-[#efeae7]"
                : "bg-white text-[#042F2E] border border-[#042F2E]/20"
            }`}
          >
            Preview (1 front + back)
          </button>
          <button
            onClick={() => setMode("all")}
            data-testid="mode-all"
            className={`px-5 py-2 rounded-full text-sm font-medium tracking-wide transition ${
              mode === "all"
                ? "bg-[#042F2E] text-[#efeae7]"
                : "bg-white text-[#042F2E] border border-[#042F2E]/20"
            }`}
          >
            Show all 58 + back
          </button>
          <div className="flex items-center gap-2 ml-2">
            <label className="text-xs text-[#042F2E]/60">Zoom</label>
            <input
              type="range"
              min="0.15"
              max="0.6"
              step="0.05"
              value={scale}
              onChange={(e) => setScale(parseFloat(e.target.value))}
              data-testid="zoom-slider"
            />
          </div>
        </div>
      </div>

      {/* CARDS DISPLAY */}
      {mode === "preview" ? (
        <div className="flex flex-wrap items-start justify-center gap-12">
          {/* Sample Front: Card 1 — I GET TO */}
          <div className="flex flex-col items-center gap-3">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardFront card={DECK_GEN[0]} />
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[#042F2E]/50 mt-3">
              SAMPLE FRONT · CARD 01 · MIND
            </div>
          </div>

          {/* Card Back */}
          <div className="flex flex-col items-center gap-3">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardBack />
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[#042F2E]/50 mt-3">
              CARD BACK · ONE DESIGN · ALL 58 CARDS
            </div>
          </div>

          {/* Sample Front: Card 13 — BODY */}
          <div className="flex flex-col items-center gap-3">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardFront card={DECK_GEN[12]} />
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[#042F2E]/50 mt-3">
              SAMPLE FRONT · CARD 13 · BODY
            </div>
          </div>

          {/* Sample Front: Card 25 — SPIRIT */}
          <div className="flex flex-col items-center gap-3">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardFront card={DECK_GEN[24]} />
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[#042F2E]/50 mt-3">
              SAMPLE FRONT · CARD 25 · SPIRIT
            </div>
          </div>

          {/* Sample Front: Card 37 — HYGIENE */}
          <div className="flex flex-col items-center gap-3">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardFront card={DECK_GEN[36]} />
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[#042F2E]/50 mt-3">
              SAMPLE FRONT · CARD 37 · HYGIENE
            </div>
          </div>

          {/* Sample Front: Card 49 — AGENCY */}
          <div className="flex flex-col items-center gap-3">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardFront card={DECK_GEN[48]} />
            </div>
            <div className="text-[11px] tracking-[0.3em] text-[#042F2E]/50 mt-3">
              SAMPLE FRONT · CARD 49 · AGENCY
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-wrap items-start justify-center gap-10">
          {DECK_GEN.map((card) => (
            <div key={card.n} className="flex flex-col items-center gap-2" data-testid={`card-wrap-${card.n}`}>
              <div
                style={{
                  transform: `scale(${scale})`,
                  transformOrigin: "top left",
                  width: 825 * scale,
                  height: 1425 * scale,
                }}
              >
                <CardFront card={card} />
              </div>
              <div className="text-[10px] tracking-[0.3em] text-[#042F2E]/50 mt-2">
                {String(card.n).padStart(2, "0")} · {card.cat}
              </div>
            </div>
          ))}
          {/* Back */}
          <div className="flex flex-col items-center gap-2">
            <div
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                width: 825 * scale,
                height: 1425 * scale,
              }}
            >
              <CardBack />
            </div>
            <div className="text-[10px] tracking-[0.3em] text-[#042F2E]/50 mt-2">
              BACK · ALL 58
            </div>
          </div>
        </div>
      )}

      {/* FULL-RESOLUTION OFF-SCREEN RENDER for Playwright element.screenshot() */}
      {/* Each card lives at its true 825×1425 pixels so it can be captured at 1:1 print resolution. */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          left: -100000,
          top: 0,
          width: 825,
        }}
      >
        <div data-testid="render-back-full">
          <CardBack />
        </div>
        {DECK_GEN.map((card) => (
          <div key={`full-${card.n}`} data-testid={`render-card-${card.n}-full`}>
            <CardFront card={card} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardGenerator;
